<mat-card style="margin: 10px;">
  <mat-form-field appearance="outline" style="width: 100%; padding: 3px;">
    <mat-label>State *</mat-label>
    <mat-select [(value)]="SelectedState" (selectionChange)="UpdateSelectedState()">
      <mat-option *ngFor="let ddlItem of states" [value]="ddlItem.abbreviation">
        {{ddlItem.name}}
      </mat-option>
    </mat-select>

  </mat-form-field>

  <ejs-tab #TabGrid cssClass="underline-customize">
    <div class="e-tab-header">
      <div ><span style="color:dimgray">County List</span></div>
      <div><span style="color:dimgray">City List</span></div>
      <div><span style="color:dimgray">Agency List</span></div>
    </div>
    <div class="e-content">
      <!--County List-->
      <div>
        <ejs-grid
          style="margin-top: 10px;"
          [editSettings]='editSettings'
          [toolbar]='toolbar'
          [dataSource]='counties'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [filterSettings]="{type: 'CheckBox'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
          (beforeBatchSave)="CountyBatchSave($event)"
          locale="en_US"
        >
          <e-columns>
            <e-column field='ID' headerText='ID' textAlign='Left' [visible]="false" [allowEditing]="false"></e-column>
            <e-column field='County' headerText='County' textAlign='Left'></e-column>
            <e-column field='State' headerText='State' textAlign='Left' [defaultValue]="SelectedState" [allowEditing]="false"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
            <!--City List-->
      <div>
        <ejs-grid
          style="margin-top: 10px;"
          [editSettings]='editSettings'
          [toolbar]='toolbar'
          [dataSource]='cities'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [filterSettings]="{type: 'CheckBox'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
          (beforeBatchSave)="CitiesBatchSave($event)"
          #CitiesGrid
          locale="en_US"
        >
          <e-columns>
            <e-column field='ID' headerText='ID' textAlign='Left' [visible]="false" [allowEditing]="false"></e-column>
            <e-column field='City' headerText='City' textAlign='Left'></e-column>
            <e-column field='County' headerText='County' textAlign='Left' editType= 'dropdownedit'></e-column>
            <e-column field='State' headerText='State' textAlign='Left' [defaultValue]="SelectedState" [allowEditing]="false"></e-column>
          </e-columns>
        </ejs-grid>
      </div>

      <!--Agency List-->
      <div>
        <ejs-grid
          style="margin-top: 10px;"
          [editSettings]='editSettings'
          [toolbar]='toolbar'
          [dataSource]='AgencyList'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [filterSettings]="{type: 'CheckBox'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
          (beforeBatchSave)="AgencyBatchSave($event)"
          #AgencyGrid
          locale="en_US"
        >
          <e-columns>
            <e-column field='ID' headerText='ID' textAlign='Left' [visible]="false" [allowEditing]="false"></e-column>
            <e-column field='DeptName' headerText='Agency' textAlign='Left'></e-column>
            <e-column field='DeptORI' headerText='ORI' textAlign='Left'></e-column>
            <e-column field='County' headerText='County' textAlign='Left' editType= 'dropdownedit'></e-column>
            <e-column field='State' headerText='State' textAlign='Left' [defaultValue]="SelectedState" [allowEditing]="false"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </ejs-tab>
</mat-card>

